module.exports = __webpack_public_path__ + "img/sc-4p-blank.ba93ed0e.png";